<template>
  <v-container fluid class="pt-0">
    <v-row class="primary darken-2 pt-12">
      <v-col cols="12" class="px-12 mt-10 d-flex flex-row justify-space-between">
        <h2 class="white--text">Panel de administración</h2>
        <v-btn large class="font-weight-bold" color="white" @click.stop="logOut()">Cerrar sesión</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="8" offset-md="2" class="mt-5">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="font-weight-bold">Bolsa de trabajo</v-col>
              <v-col cols="12" sm="12" md="6" class="text-right font-weight-bold">
                <v-btn
                  class="font-weight-bold"
                  outlined
                  color="primary"
                  @click="showNewJob = !showNewJob"
                >Nueva vacante</v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              single-expand
              :expanded.sync="expanded"
              item-key="id"
              show-expand
            >
              <template v-slot:item.puesto="{item}">
                <h3 class="pt-3 pb-2 my-0 font-weight-bold">{{item.puesto}}</h3>
              </template>
              <template v-slot:item.contacto="{item}">
                <h3 class="pt-3 pb-2 my-0 font-weight-bold">{{item.contacto}}</h3>
                <h4 class="py-1 my-0">{{item.contacto_tel | phone}}</h4>
                <h5 class="py-1 my-0">{{item.contacto_email}}</h5>
              </template>
              <template v-slot:item.sueldo="{item}">
                <h3 class="pt-3 pb-2 my-0 font-weight-bold">{{item.sueldo | currency}}</h3>
              </template>
              <template v-slot:item.actions="{item}">
                <v-btn fab small depressed color="error" class="ml-3" @click="deleteItem(item)">
                  <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td class="grey lighten-4" :colspan="headers.length">
                  <v-row v-if="typeof item.postulados !== 'undefined'">
                    <v-col
                      cols="12"
                      v-for="(cand, index) in item.postulados"
                      :key="index.toString()"
                    >
                      <v-card flat>
                        <v-card-title class="font-weight-bold">{{cand.contacto}}</v-card-title>
                        <v-card-text class="font-weight-bold">
                          <p>{{cand.contacto_tel | phone}}</p>
                          <p>El currículum fue eliminado permanentemente, por lo que no puede ser mostrado.</p>
                          <v-btn
                            :href="cand.url"
                            color="primary"
                            depressed
                            class="font-weight-bold"
                            target="blank"
                            v-if="typeof cand.url !== 'undefined'"
                          >Ver CV</v-btn>
                          <v-btn
                            @click="showDelete(item.id, cand.ref)"
                            color="primary"
                            depressed
                            class="font-weight-bold ml-4"
                            v-if="typeof cand.url !== 'undefined'"
                          >Eliminar CV</v-btn>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <v-card flat>
                        <v-card-text
                          class="font-weight-bold"
                        >Aún no tienes ningún postulado para esta oferta de empleo</v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showNewJob"
      persistent
      max-width="500"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="font-weight-bold primary white--text">Nueva vacante</v-card-title>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field outlined v-model="job.puesto" hide-details label="Nombre del puesto"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field outlined v-model="job.sueldo" hide-details label="Sueldo tentativo"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                v-model="job.requisitos"
                hide-details
                label="Requisitos del puesto"
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                v-model="job.contacto"
                hide-details
                label="Nombre del contacto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                outlined
                v-model="job.contacto_tel"
                hide-details
                maxlength="14"
                v-mask="'(###) ###-####'"
                label="Teléfono del contacto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                outlined
                v-model="job.contacto_email"
                hide-details
                label="Correo del contacto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end align-center pr-5 pb-5">
          <v-btn
            class="font-weight-bold"
            text
            color="grey"
            @click="showNewJob = !showNewJob"
          >cancelar</v-btn>
          <v-btn class="font-weight-bold" color="primary" @click="writeUserData()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteCVDialog"
      persistent
      max-width="500"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="font-weight-bold primary white--text">¿Eliminar este currículum vitae?</v-card-title>
        <v-card-text
          class="mt-5"
        >Estas seguro de querer eliminar este currículum permanentemente. Esta acción no se puede deshacer.</v-card-text>
        <v-card-actions class="d-flex justify-end align-center pr-5 pb-5">
          <v-btn
            class="font-weight-bold"
            text
            color="grey"
            @click="deleteCVDialog = !deleteCVDialog"
          >cancelar</v-btn>
          <v-btn
            class="font-weight-bold"
            color="primary"
            @click="deleteCV()"
            :disabled="isLoading"
            :loading="isLoading"
          >Si, eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
</style>
<script>
import firebase from "firebase";
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask
  },
  mounted() {
    let self = this;
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        self.user = user;
      } else {
        self.$router.replace("/");
      }
    });
    if (self.user) {
      firebase
        .database()
        .ref("/")
        .on("value", function(snapshot) {
          self.items = snapshot
            .val()
            .jobs.filter(item => item.status != "deleted");
          self.id_reference = snapshot.val().id;
        });
    }
  },
  data() {
    return {
      user: {},
      showNewJob: false,
      expanded: [],
      id_reference: null,
      id_to_delete: 0,
      isLoading: false,
      ref_to_delete: "",
      deleteCVDialog: false,
      job: {
        contacto: "",
        contacto_email: "",
        contacto_tel: "",
        puesto: "",
        sueldo: "",
        requisitos: ""
      },
      headers: [
        {
          value: "puesto",
          text: "Puesto",
          sortable: true
        },
        {
          value: "contacto",
          text: "Contacto",
          sortable: true
        },
        {
          value: "sueldo",
          text: "Propuesta salarial",
          sortable: true
        },
        { text: "Acciones", value: "actions" },
        { text: "", value: "data-table-expand" }
      ],
      items: []
    };
  },
  methods: {
    logOut() {
      let self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$router.replace("/");
        })
        .catch(function(error) {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
    },
    writeUserData() {
      let self = this;
      let database = firebase.database();
      this.job = { ...this.job, id: this.id_reference };
      database.ref("/jobs/" + self.id_reference).set({
        ...self.job
      });
      self.id_reference++;
      database.ref("/id").set(self.id_reference);
      self.job = {
        contacto: "",
        contacto_email: "",
        contacto_tel: "",
        puesto: "",
        sueldo: "",
        requisitos: ""
      };
      self.showNewJob = false;
    },
    showDelete(id, ref) {
      this.id_to_delete = id;
      this.ref_to_delete = ref;
      this.deleteCVDialog = !this.deleteCVDialog;
    },
    deleteCV() {
      var storage = firebase.storage();
      var storageRef = storage.ref();
      var desertRef = storageRef.child(this.ref_to_delete);
      let database = firebase.database();

      let self = this;
      // Delete the file
      desertRef
        .delete()
        .then(function() {
          database
            .ref(
              "/jobs/" +
                self.id_to_delete +
                "/postulados/" +
                self.ref_to_delete +
                "/url"
            )
            .set(null);
          self.isLoading = false;
          self.deleteCVDialog = false;
        })
        .catch(function(error) {
          // Uh-oh, an error occurred!
          alert(error);
        });
    },
    deleteItem(item) {
      let database = firebase.database();
      let newItem = { ...item, status: "deleted" };
      database.ref("/jobs/" + newItem.id).set({ ...newItem });
    }
  }
};
</script>